import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  ActionsDistributionResponse,
  Risque,
  RisqueResponse,
  SourceRisqueType,
} from '../../types/risqueTypes'
import {
  addRisqueApi,
  addRisquesToActionApi,
  deleteRisqueApi,
  getActionsDistributionBySecurityControl,
  getAllRisques,
  getRisqueByActionIdApi,
  getRisqueByPlanIdApi,
  getRisquebyIdApi,
  getRisquesByMissionIdApi,
  removeRisquesFromActionApi,
  updateRisqueApi,
  extractRisksFromFileApi,
} from '../../api/risqueApi'
import { getRisksFromRelatedControls } from '../../api/securityControlsApi'
import { handleError } from '../../utils/errorHandler'

export const getRisques = createAsyncThunk<
  {
    risques: Risque[]
    total: number
    totalPages: number
    status?: number
    erreur?: boolean
    message?: string
  },
  { search?: string; page?: number; pageSize?: number },
  { rejectValue: string }
>('risque/getAllRisques', async ({ search, page, pageSize }, thunkAPI) => {
  try {
    const response = await getAllRisques({ search, page, pageSize })
    return {
      risques: response.risques,
      total: response.total,
      totalPages: response.totalPages,
      status: response.status,
      message: response.message,
      erreur: response.erreur,
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const deleteRisque = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('risque/deleteRisque', async (RisqueId, thunkAPI) => {
  try {
    await deleteRisqueApi(RisqueId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const fetchRisksFromRelatedControls = createAsyncThunk<
  Risque[],
  string,
  { rejectValue: string }
>('securityControls/fetchRisksFromRelatedControls', async (id, thunkAPI) => {
  try {
    const response = await getRisksFromRelatedControls(id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addRisque = createAsyncThunk<
  Risque,
  Risque,
  { rejectValue: string }
>('risque/addRisque', async (newRisque, thunkAPI) => {
  try {
    console.log({ newRisque })
    const response = await addRisqueApi(newRisque)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getRisquebyId = createAsyncThunk<
  Risque,
  string,
  { rejectValue: string }
>('risque/getRisquebyId', async (RisqueId, thunkAPI) => {
  try {
    const response = await getRisquebyIdApi(RisqueId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updateRisque = createAsyncThunk<
  Risque,
  { updatedRisque: Risque; _id: string },
  { rejectValue: string }
>('risque/updateRisque', async ({ updatedRisque, _id }, thunkAPI) => {
  try {
    const response = await updateRisqueApi(updatedRisque, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getRisquesByMissionId = createAsyncThunk<
  RisqueResponse,
  string,
  { rejectValue: string }
>('risque/getRisquesByMissionId', async (MissionId, thunkAPI) => {
  try {
    const response = await getRisquesByMissionIdApi(MissionId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getRisqueByActionId = createAsyncThunk<
  RisqueResponse,
  string,
  { rejectValue: string }
>('risque/getRisqueByActionId', async (ActionId, thunkAPI) => {
  try {
    const response = await getRisqueByActionIdApi(ActionId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addRisquesToAction = createAsyncThunk<
  RisqueResponse,
  { SourceRisque: string[]; _id: string },
  { rejectValue: string }
>('risque/addRisquesToAction', async ({ SourceRisque, _id }, thunkAPI) => {
  try {
    const response = await addRisquesToActionApi(SourceRisque, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const removeRisquesFromAction = createAsyncThunk<
  RisqueResponse,
  { SourceRisque: SourceRisqueType; _id: string },
  { rejectValue: string }
>('risque/addRisquesToAction', async ({ SourceRisque, _id }, thunkAPI) => {
  try {
    const response = await removeRisquesFromActionApi(SourceRisque, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getRisqueByPlanId = createAsyncThunk<
  RisqueResponse,
  string,
  { rejectValue: string }
>('risque/getRisqueByPlanId', async (PlanId, thunkAPI) => {
  try {
    const response = await getRisqueByPlanIdApi(PlanId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const fetchActionsDistribution = createAsyncThunk<
  ActionsDistributionResponse,
  string,
  { rejectValue: string }
>('securityControl/fetchActionsDistribution', async (riskId, thunkAPI) => {
  try {
    return await getActionsDistributionBySecurityControl(riskId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const extractRisksFromFile = createAsyncThunk<
  Risque[],
  { file: File; planId: string },
  { rejectValue: string }
>('risque/extractRisksFromFile', async ({ file, planId }, thunkAPI) => {
  try {
    const response = await extractRisksFromFileApi(file, planId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
